import { ActiveTab } from '@/constants/chat'
import { Negotiation, NegotiationType } from '@/redux/types/negotiationWebsocket'
import { PhaseType } from '@/redux/slices/timerConfigurationSlice'

type TeamDummyAssignment = {
  botId: number
  botName: string
  teamId: number
  teamName: string
} | null

export const getPhaseTransitionKey = (
  manualMode: boolean,
  phaseId: number | null,
  currentRound: number,
  currentPhase: PhaseType | null,
  isRandRPhase: boolean,
  isAdvisorPhase: boolean,
  isNegotiationPhase: boolean,
  isDecisionPhase: boolean
): string | null => {
  if (manualMode) {
    if (isDecisionPhase) return `${currentRound}-decision`
    if (isNegotiationPhase) return `${currentRound}-negotiation`
    if (isAdvisorPhase) return `${currentRound}-advisor`
    if (isRandRPhase) return `${currentRound}-randr`
    return null
  }

  if (currentPhase) return `${currentRound}-${currentPhase}`
  if (phaseId != null) return `phase-${phaseId}`
  return null
}

export const getNegotiationPhaseTargetTab = (
  teamDummyAssignment: TeamDummyAssignment,
  activeNegotiations: Negotiation[]
): string | null => {
  if (teamDummyAssignment) {
    return ActiveTab.DummyLLMChat
  }

  const publicRoom = activeNegotiations.find(
    (negotiation) => negotiation.negotiation_type === NegotiationType.PUBLIC_ROOM
  )

  return publicRoom ? String(publicRoom.negotiationId) : null
}
